import { useEffect, useState } from 'react';

// Hook for conditionally rendering content based on the render context.
//
// Use this if you have an external library that cannot be server side rendered
//
// If you are conditionally rendering internal content (i.e content that does
// not rely on external dependencies), consider trying to re-architect things
// so it can be rendering in either context.
//
// Usage:
//
// ```js
//   const Componenet = () => {
//     const hydrated = useServerSideRendering();
//
//     return (
//       <>
//        {hydrated && <ExternalLibraryComponent />}
//       </>
//     )
//   }
// ```
const useServerSideRendering = () => {
  const [hydrated, setHydrate] = useState(false);

  useEffect(() => {
    setHydrate(true);
  }, []);

  return hydrated;
};

export default useServerSideRendering;
